module.exports = __webpack_public_path__ + "img/device.6769cd5d.png";